<template>
	<digital-clock v-if="clock.type == 'D'" :clock="clock" />
	<analog-clock v-else-if="clock.type == 'A'" :clock="clock" />	
</template>
<script>
import DigitalClock from '@/components/Question/Clock/DigitalClock'
import AnalogClock from '@/components/Question/Clock/AnalogClock'

export default {
	name : 'show-clock',
	components : {
		DigitalClock,
		AnalogClock
	},
	props : {
		clock : {
			type : Object,
			required : true
		}
	},
	data(){
		return {
			
		}
	},
}
</script>